// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"ManageUsers_overlayWrapper__9oJgr","viewBox":"ManageUsers_viewBox__izKtf","tablestyle":"ManageUsers_tablestyle__cLm28"};